"use client";
import { createPlayer } from "../../player/create-player.js";
import { audioFeatures } from "@videojs/core/dom";
//#region src/presets/audio/player.ts
/** Preconfigured player with the standard audio features. */
const { Player: AudioPlayer, usePlayer } = createPlayer({
	features: audioFeatures,
	displayName: "AudioPlayer"
});
//#endregion
export { AudioPlayer, usePlayer };

//# sourceMappingURL=player.js.map